module.exports = __webpack_public_path__ + "static/media/cloud-a-v3@2x.13b754fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-a-v3@2x.png
// module id = 91
// module chunks = 0